import { render, staticRenderFns } from "./register-final-report-app.vue?vue&type=template&id=71fd7ee8"
import script from "./register-final-report-app.vue?vue&type=script&lang=js"
export * from "./register-final-report-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports